import axios from "axios";
import { loginAs } from "./aaffs.service";
import { loginAsTecnico } from "./tecnico.service";
import jwt_decode from "jwt-decode";
import { loginAsConsultor } from "./consultor.service";
import { loginAsComercial } from "./commercial.service";
import { loginAsSupplier } from "./proveedor.service";
import { toast } from "react-toastify";
import i18n from "../i18n";
import { clearSessionStoragePreservingVersion } from "../utilities/appVersion";
import { desconectarChatElite } from "./chatElite.socket";

let _isLoggingIn = false;

const withLoginLoading = (fn) => async (...args) => {
  if (_isLoggingIn) return;
  _isLoggingIn = true;
  const toastId = toast.loading(i18n.t("common:loginAs.loading"));
  document.body.classList.add("login-as-loading");
  try {
    await fn(...args);
  } catch (error) {
    toast.update(toastId, {
      render: i18n.t("common:loginAs.error"),
      type: "error",
      isLoading: false,
      autoClose: 4000,
    });
    document.body.classList.remove("login-as-loading");
    _isLoggingIn = false;
  }
};

export const signIn = async ({ email, password }) => {
  const data = { email, password };
  try {
    const response = await axios.post("auth/login", data);
    if (response.status === 200) {
      localStorage.setItem("token", response.data.token);
      localStorage.setItem("numActivo", 0);
      //window.location.replace("/Inicio");
    }
    return response;
  } catch (err) {
    console.log(err);
    return err;
    //return window.location.replace("/login")
  }
};
export const firstSignIn = async ({ email, password }) => {
  const data = { email, password };
  try {
    const response = await axios.post("auth/first-login", data);
    if (response.status === 200) {
      localStorage.setItem("token", response.data.token);
      localStorage.setItem("numActivo", 0);
      window.location.replace("/");
    }
    return response;
  } catch (err) {
    console.log(err.response);
    return window.location.replace("/login")
  }
};
export const logout = async () => {
  desconectarChatElite();
  // Limpiar todos los datos de sesión, incluyendo states y groups cacheados
  localStorage.clear();
  clearSessionStoragePreservingVersion();
  window.dispatchEvent(new Event("storage"));
};

const _loginAsAndRedirect = (token) => {
  localStorage.setItem("token", token);
  localStorage.setItem("back-url", window.location.href);
  localStorage.setItem("numActivo", 0);
  window.location = "/";
};

export const loginAsAAFF = withLoginLoading(async (nifAAFF) => {
  const { token } = await loginAs(nifAAFF);
  if (!token) throw new Error("No token");
  _loginAsAndRedirect(token);
});

export const LoginAsTech = withLoginLoading(async (nifTech) => {
  const { token } = await loginAsTecnico(nifTech);
  _loginAsAndRedirect(token);
});

export const LoginAsConsul = withLoginLoading(async (nifConsul) => {
  const { token } = await loginAsConsultor(nifConsul);
  _loginAsAndRedirect(token);
});

export const LoginAsCommer = withLoginLoading(async (nifCommer) => {
  const { token } = await loginAsComercial(nifCommer);
  _loginAsAndRedirect(token);
});

export const LoginAsSupp = withLoginLoading(async (nifSupp) => {
  const { token } = await loginAsSupplier(nifSupp);
  _loginAsAndRedirect(token);
});

export const backToOwnAccount = (ownToken) => {
  localStorage.setItem("token", ownToken);
  window.location = localStorage.getItem("back-url") || "/"
}

export const forgotPassword = async (token) => {
  try {
    const response = await axios.post("auth/forgot-password", token);
    return response
  } catch (error) {
    console.log(error)
    return error
  }
}
export const resetPassword = async (datos) => {
  try {
    const response = await axios.post("auth/reset-password", datos);
    return response.data
  } catch (error) {
    console.log(error)
  }
}
export const checkToken = async (token) => {
  try {
    const response = await axios.post("auth/check-token", token);
    return response.data
  } catch (error) {
    console.log(error)
  }
}
export const deleteToken = async (token) => {
  try {
    const response = await axios.post("auth/delete-token", token);
    return response.data
  } catch (error) {
    console.log(error)
  }
}

export const changePassword = async (data) => {
  try {
    const response = await axios.post("auth/change-password", data);
    return response
  } catch (error) {
    console.log(error)
    return error.response
  }
}
export const changePasswordAgain = async (data) => {
  try {
    const response = await axios.post("auth/change-password-again", data);
    return response.data
  } catch (error) {
    console.log(error)
    return error.response
  }
}

export const getCaeToken = async (softwareProvider) => {
  try {
    const response = await axios.post("auth/create-cae-token", { softwareProvider });
    return response.data
  } catch (error) {
    console.log(error)
    return error.response
  }
}
